import React from "react";
import StatusBadge from "../../UI/statusBadge";
import { formatPrice } from "../../../utils/formatPrice"; // adjust path to where you put the helper

const UserInfo = ({
  name,
  phone,
  status,
  status_label,
  email,
  balance,
  loyalty_points,
  available_loyalty_points,
  points_expire_at,
  order_count,
  id,
}) => {
  const curiorInfo = [
    { title: "المعرف", value: id },
    { title: "الإسم", value: name },
    { title: "رقم الجوال", value: phone },
    { title: "الإيميل", value: email },
    { title: "الرصيد", value: formatPrice(100, balance) },
    { title: "نقاط الولاء", value: loyalty_points },
    { title: "النقاط المتاحة", value: available_loyalty_points },
    {
      title: "انتهاء النقاط",
      value: points_expire_at
        ? new Date(points_expire_at).toLocaleDateString()
        : "",
    },
    { title: "عدد الطلبات", value: order_count },
    { title: "الحالة", value: status },
  ];

  return (
    <div className="row">
      <h5 className="mb-3"> المعلومات الشخصية</h5>
      <div className="col-12">
        <ul className="two-columns">
          {curiorInfo.map((item, index) => (
            <li key={index}>
              <h4 className="font14 font700">{item.title}</h4>
              {item.title === "الحالة" ? (
                <StatusBadge status={status} statusLabel={status_label} />
              ) : (
                <p>{item.value}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserInfo;
